<template>
  <div
    :class="[
      'poster-csa',
      `${coverSizeClass}-csa`,
      !isProgressBar ? 'is-not-progress' : ''
    ]">
    <wptv-icon
      :name="'csa' + csa"
      :width="''"
      :height="''"
      :specific-alt="csaLabel(csa)"
      aria-hidden="true"
      data-wptv="item-poster-csa"
      class="icon-csa" />
  </div>
</template>

<script>
import { WptvIcon } from '../../icon'
import csa from './csa.mixin'

export default {
  name: 'PosterCsa',
  components: {
    WptvIcon
  },
  mixins: [csa],
  props: {
    csa: {
      type: Number,
      default: 1
    },
    // used to know what css to use depending of the cover width
    coverSizeClass: {
      type: String,
      default: 'large'
    },
    // used, if the progress bar is not shown, to put the csa closer to the bottom
    isProgressBar: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/abstracts/variables';
  @import '../../../scss/abstracts/mixins';

  .poster-csa {
    position: absolute;
    z-index: 3;
    width: 100%;
    justify-content: flex-end;
    align-content: center;
    display: flex;
    bottom: 35px;
    right: 15px;
    // if the progress bar is not shown, put the csa closer to the bottom
    &.is-not-progress {
      bottom: 20px;
    }
    &.tiny-csa {
      bottom: 15px;
      right: 5px;
      // if the progress bar is not shown, put the csa closer to the bottom
      &.is-not-progress {
        bottom: 10px;
      }
      .icon-csa {
        width: 0.75rem;
        height: 0.75rem;
      }
    }
    &.medium-csa {
      bottom: 30px;
      right: 10px;
      // if the progress bar is not shown, put the csa closer to the bottom
      &.is-not-progress {
        bottom: 15px;
      }
      .icon-csa {
        width: 1.125rem;
        height: 1.125rem;
      }
    }
    &.large-csa .icon-csa {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
</style>
